
import { Clock } from "lucide-react";
import { format } from "date-fns";
import { useEffect, useRef } from "react";

export const TimelineDateIndicator = () => {
  const now = new Date();
  const indicatorRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    // Scroll to the indicator with a small delay to ensure the DOM is ready
    const timer = setTimeout(() => {
      indicatorRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }, 500);

    return () => clearTimeout(timer);
  }, []);
  
  return null; // Component no longer renders anything
};
